module.exports = __webpack_public_path__ + "static/img/dash-stat-students.0f6a0e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/dash-stat-students.png
// module id = wN8/
// module chunks = 1